import { render, staticRenderFns } from "./button-group.vue?vue&type=template&id=ee639da6"
import script from "./button-group.vue?vue&type=script&setup=true&lang=js"
export * from "./button-group.vue?vue&type=script&setup=true&lang=js"
import style0 from "./button-group.vue?vue&type=style&index=0&id=ee639da6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports